export class AuthError extends Error {
  constructor(message) {
    super(message)
  }
}

export function getAuthToken() {
  const rawAuthData = window.localStorage.getItem('ls.authorizationData')
  if (rawAuthData) {
    const authData = JSON.parse(rawAuthData)
    if (!authData.accessToken) {
      throw new AuthError('unable to read stored token')
    }
    return authData.accessToken
  }
}

export function getAuthData() {
  const rawAuthData = window.localStorage.getItem('ls.authorizationData')
  if (rawAuthData) {
    const authData = JSON.parse(rawAuthData)
    if (!authData.accessToken) {
      throw new AuthError('unable to read stored token')
    }
    return authData
  }
}

export function getCompanyId() {
  const rawCompanyId = window.localStorage.getItem('ls.defaultCompany')
  if (rawCompanyId) {
    const companyId = JSON.parse(rawCompanyId)
    if (!companyId) {
      throw new AuthError('unable to read stored company id')
    }
    return companyId
  }
}
